import React, { Component } from "react";
import { connect } from "react-redux";
import URLSearchParams from 'url-search-params'
import { Redirect, Route, Switch } from "react-router-dom";

import { LocaleProvider, message } from "antd";
import { IntlProvider } from "react-intl";

import AppLocale from "lngProvider";
import MainApp from "./MainApp";
import SignIn from "../SignIn";
import ForgotPassword from "../ForgotPassword";
import { onLayoutTypeChange, onNavStyleChange, setThemeType } from "appRedux/actions/Setting";
import Terms from '../../containers/Terms/index';
import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  THEME_TYPE_DARK
} from "../../constants/ThemeSetting";
import { authRefresh, getUser, userSignOut } from "../../appRedux/actions/Auth";
import OsimisViewer from "../OsimisViewer";
import CircularProgress from "../../components/CircularProgress";
import UserRoleSelection from "../UserRoleSelection";
import Launchpad from "../Launchpad";
import VerifyAccount from "../VerifyAccount";
import ResetPassword from "../ResetPassword";
import AuthenticatorQR from "../AuthenticatorQR";
import VerifyAuthenticatorCode from "../VerifyAuthOtp";
import VerifyEmailOtp from "../VerifyEmailOtp";

const RestrictedRoute = ({ component: Component, authUser, ...rest }) =>
  <Route
    {...rest}
    render={props =>
      authUser ? (
        authUser.authenticated ?
          (
            authUser.role ?
              <Component {...props} role={authUser.role} /> :
              <Redirect
                to={{
                  pathname: '/user-role-selection',
                  state: { from: props.location }
                }}
              />
          ) :
          <Redirect
            to={{
              pathname: '/verify-account',
              state: { from: props.location }
            }}
          />
      ) : <Redirect
        to={{
          pathname: '/signin',
          state: { from: props.location }
        }}
      />}
  />;


class App extends Component {

  constructor(props) {
    super(props);
    let initialValue = {
      '@primary-color': '#038fde',
      '@secondary-color': '#fa8c16',
      '@text-color': '#545454',
      '@heading-color': '#535353',
      '@nav-dark-bg': '#003366',
      '@nav-dark-text-color': '#038fdd',
      '@header-text-color': '#262626',
      '@layout-header-background': '#fefefe',
      '@layout-footer-background': '#fffffd',
      '@body-background': '#f5f5f5',
      '@hor-nav-text-color': '#fffffd'
    };
    let vars = {};

    try {
      vars = Object.assign({}, initialValue, JSON.parse(localStorage.getItem('app-theme')));
    } finally {
      this.state = { vars, initialValue, isCustomizerOpened: false };
      window.less
        .modifyVars(vars)
        .then(() => {
        })
        .catch(error => {
          message.error(`Failed to update theme`);
        });
    }
  }

  setLayoutType = (layoutType) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  setNavStyle = (navStyle) => {
    if (navStyle === NAV_STYLE_DEFAULT_HORIZONTAL ||
      navStyle === NAV_STYLE_DARK_HORIZONTAL ||
      navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL ||
      navStyle === NAV_STYLE_ABOVE_HEADER ||
      navStyle === NAV_STYLE_BELOW_HEADER) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };

  componentWillMount() {
    const USESSIONID = sessionStorage.getItem("USESSIONID");
    if (USESSIONID !== null && USESSIONID !== "") {
      this.props.authRefresh(true);
    } else {
      if (this.shouldLogout()) {
        this.props.userSignOut();
      }
    }
    const params = new URLSearchParams(this.props.location.search);
    if (params.has("theme")) {
      this.props.setThemeType(params.get('theme'));
    }
    if (params.has("nav-style")) {
      this.props.onNavStyleChange(params.get('nav-style'));
    }
    if (params.has("layout-type")) {
      this.props.onLayoutTypeChange(params.get('layout-type'));
    }
  }

  shouldLogout = () => {
    const { pathname } = this.props.location;
    const matchfound = pathname.startsWith("/osimisviewer/");
    return matchfound ? false : true
  }

  // componentDidMount() {
  //   window.addEventListener("beforeunload", this.handleBeforeUnload);
  //   window.addEventListener("unload", this.handleUnload);
  // }

  // handleBeforeUnload = (e) => {
  //   e.preventDefault();
  //   e.returnValue = "";
  // }

  // handleUnload = (e) => {
  //   this.props.userSignOut();
  // }

  // componentWillUnmount() {
  //   window.removeEventListener('beforeunload', this.handleUnload);
  //   window.removeEventListener('unload', this.handleUnload);
  // }

  render() {
    const { match, location, themeType, layoutType, navStyle, locale, appLoading, authUser } = this.props;
    if (themeType === THEME_TYPE_DARK) {
      document.body.classList.add('dark-theme');
    } else if (document.body.classList.contains('dark-theme')) {
      document.body.classList.remove('dark-theme');
    }
    if (appLoading) {
      return <CircularProgress />
    }
    if (location.pathname === '/') {
      if (!authUser) {
        return (<Redirect to={'/signin'} />);
      }
      if (!authUser.authenticated) {
        return (<Redirect to={'/verify-account'} />);
      } 
      if (!authUser.isAuthenticator){
        return (<Redirect to={`/get-authenticator`} />);
      } 
      if (authUser.isAuthenticator && !authUser.otpVerified){
        return (<Redirect to={`/verify-auth-otp`} />);
      } 
      else {
        if (authUser.role) {
          const routeAccess = authUser.role.replace("ROLE_", "");
          return (<Redirect to={`/${routeAccess.toLowerCase()}/dashboard`} />);
        } else {
          return (<Redirect to={`/user-role-selection`} />);
        }
      }
    }
    this.setLayoutType(layoutType);

    this.setNavStyle(navStyle);

    const currentAppLocale = AppLocale[locale.locale];
    return (
      <LocaleProvider locale={currentAppLocale.antd}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}>

          <Switch>
            <Route exact path='/signin' component={SignIn} />
            <Route exact path='/get-authenticator' component={AuthenticatorQR} />
            <Route exact path='/verify-auth-otp' component={VerifyAuthenticatorCode} />
            <Route exact path='/verify-email-otp' component={VerifyEmailOtp} />
            <Route exact path='/forgot-password' component={ForgotPassword} />
            <Route exact path='/reset-password' component={ResetPassword} />
            <Route exact path='/verify-account' component={VerifyAccount} />
            <Route exact path='/osimisviewer/:id' component={OsimisViewer} />
            <Route exact path='/terms' component={Terms} />
            <Route exact path='/launchpad' component={Launchpad} />
            {
              authUser&& authUser.authenticated &&
              <Route exact path='/user-role-selection' component={UserRoleSelection} />
            }
            <RestrictedRoute
              path={`${match.url}`}
              component={MainApp}
              authUser={authUser}
            />
          </Switch>
        </IntlProvider>
      </LocaleProvider>
    )
  }
}

const mapStateToProps = ({ settings, auth }) => {
  const { locale, navStyle, themeType, layoutType } = settings;
  const { appLoading, authUser } = auth;
  return { locale, navStyle, themeType, layoutType, appLoading, authUser }
};
export default connect(mapStateToProps, { authRefresh, getUser, userSignOut, setThemeType, onNavStyleChange, onLayoutTypeChange })(App);
